import { TransitionClass_$ctor_Z207A3CFB, TransitionProperty_$ctor_Z207A3CFB, TransitionTimingFunction_$ctor_Z207A3CFB, TransitionDuration_$ctor_Z207A3CFB, TransitionDelay_$ctor_Z207A3CFB } from "../Types/Transition.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const TransitionDelay = TransitionDelay_$ctor_Z207A3CFB(new Property_CssProperty(288));

export const TransitionDuration = TransitionDuration_$ctor_Z207A3CFB(new Property_CssProperty(289));

export const TransitionTimingFunction = TransitionTimingFunction_$ctor_Z207A3CFB(new Property_CssProperty(291));

export const TransitionProperty = TransitionProperty_$ctor_Z207A3CFB(new Property_CssProperty(290));

export const Transition = TransitionClass_$ctor_Z207A3CFB(new Property_CssProperty(287));

